<mat-dialog-content class="mat-typography">
  <div>
    <div class="ey_logo">
      <img src="./../../../assets/img/EY_logo13.png" height="50px" width="50px">
    </div>
    <div class="startup_heading">PMC Calendar Privacy Notice</div>
  </div>
  <hr>
  <div class="main-content">
    <p><b>1. Introduction</b><br>
      This Privacy Notice is intended to describe the practices EY follows in relation to the PMC Calendar (“Tool”) with
      respect to the privacy of all individuals whose personal data is processed and stored in the Tool.
      <br><br><b> 2. Who manages the Tool?</b><br>
      “EY” refers to one or more of the member firms of Ernst & Young Global Limited (“EYG”), each of which is a
      separate legal entity and can act as a data controller in its own right. The entity that is acting as data
      controller by providing this Tool on which your personal data will be processed and stored is Ernst and Young
      Services Private Limited.
      The personal data you provide in the Tool is shared by Ernst and Young Services Private Limited with one or more
      member firms of EYG (see “Who can access your information” section below).
      <br>
      <b>Ernst and Young Services Private Limited</b>
      <br>
      6th Floor, Worldmark 1, Asset Area 11, Hospitality District,<br>
      Indira Gandhi International Airport, New Delhi-110037, India<br>
      The Tool is hosted on servers in India Data Centre, Gurgaon India.

      <br><br><b>3. Why do we need your information? </b><br>
      The Tool will be used to effectively schedule and automate the process of Asset management & Preventive
      maintenance of the assets to be performed in each EY location throughout the year

      Your personal data processed in the Tool is used as follows:
      - India locations are divided into Zones i.e. North, South, West, East. Each zone has its primary SPOC, called
      Zonal manager.
      -Zones are further broken into Locations i.e. In North Zone, Delhi, Noida, Chandigarh will be location. Each
      Location has its primary SPOC, called Location Coordinator.
      -Under Location, there will EY offices i.e. In Gurgaon Location, GVT, Cyber court are different offices. Each
      Office has its primary SPOC, called Office Spoc.
      -Each Zonal manager will create the inventory of all the assets under his/her zone in the system, and will update
      various asset details, like AMC Visit Dates
      -System Admin can also create assets for all the zones.
      -Defined AMC visits are displayed in Calendar view in system, and timely reminders are sent to Office Spoc, and
      location coordinator informing them about upcoming AMC visits.
      -Office Spoc, and location coordinator can update the status of AMC visits so as to make tracking of data easier

      EY relies on the following basis to legitimize the processing of your personal data in the Tool: EY office
      workplace management. The provision of your personal data to EY is optional. However, if you do not provide all or
      part of your personal data, we may be unable to carry out the purposes for processing.

      <br><br><b>4. What type of personal data is processed in the Tool? </b><br>

      The Tool processes these personal data categories: Name, email address and contact number details of EY employees,
      and EY Contractual Employees. This data is sourced from: Global Human Resource Database(GHRDB).
      <br><br><b> 5. Sensitive Personal Data</b><br>
      Sensitive personal data reveals your racial or ethnic origin, political opinions, religious or philosophical
      beliefs, trade union membership, genetic data, biometric data, data concerning health or data concerning sex life
      or sexual orientation.
      EY does not intentionally collect any sensitive personal data from you via the Tool. The Tool’s intention is not
      to process such information.
      <br><br><b>6. Who can access your information?</b><br>
      Your personal data is accessed in the Tool by the following persons/teams:
      EY India Employees only for whom access will be created in the system by System Admin. Individuals outside the EY
      organization will NOT have access to system.
      There are following roles in the system:
      Zone Manager
      Location Manager
      Office SPOC
      And
      Where they are Located: India
      What the purpose is for which they need access: To create assets inventory, add/update asset Details, update AMC
      status
      What level of access: Edit.
      The access rights detailed above involves transferring personal data in various jurisdictions (including
      jurisdictions outside the European Union) in which EY operates (EY office locations are listed at <a
        target="_blank" href="http://www.ey.com/ourlocations">www.ey.com/ourlocations</a>). EY will process your
      personal data in the Tool in accordance with applicable law and professional regulations in your jurisdiction.
      Transfers of personal data within the EY network are governed by EY’s Binding Corporate Rules (<a target="_blank"
        href="C:\Users\tomesel\AppData\Local\Microsoft\Windows\INetCache\Content.Outlook\6ASNR839\www.ey.com\bcr">www.ey.com/bcr</a>).
      <br><br><b>7. Data retention</b><br>
      The policies and/or procedures for the retention of personal data in the Tool are:
      Data retention is in accordance with EY <a target="_blank"
        href="http://chas.ey.net/GLOBAL1/CBS/PPR/EMEIAPOLPRACPPR.NSF/AllDocsByDocKey/SCHN-8YVQ67?OpenDocument&env1=DARY-9AYJBU&env2=1&env3=null">Records
        Retention Global Policy</a> and the applicable Global, Area, Region or Country Retention Schedule. Please
      provide details of applicable retention period. If you do not have these details, please contact the <a
        target="_blank"
        href="https://share.ey.net/sites/riskmanagement_site/SitePages/Records and Information Management.aspx">Records
        and Information Management (RIM) team</a> within Risk Management for assistance.

      - Common Data:
      - Archived Data
      - Log Data
      Your personal data will be retained in compliance with privacy laws and regulations.
      After the end of the data retention period, your personal data will be deleted.
      <br><br><b>8. Security</b><br>
      EY is committed to making sure your personal data is secure. To prevent unauthorized access or disclosure, EY has
      technical and organizational measures to safeguard and secure your personal data. All EY personnel and third
      parties EY engages to process your personal data are obliged to respect your data’s confidentiality.
      <br><br><b>9. Controlling your personal data</b><br>
      EY will not transfer your personal data to third parties (other than any external parties referred to in section 6
      above) unless we have your permission or are required by law to do so.
      You are legally entitled to request details of EY’s personal data about you.
      To confirm whether your personal data is processed in the Tool or to access your personal data in the Tool,
      contact your usual EY representative or email your request to global.data.protection@ey.com.

      <br><br><b>10. Rectification, erasure, restriction of processing or data portability</b><br>
      You can confirm your personal data is accurate and current. You can request rectification, erasure, restriction of
      processing or a readily portable copy of your personal data by contacting your usual EY representative or by
      sending an e-mail to global.data.protection@ey.com.
      <br><br><b>11. Complaints</b><br>
      If you are concerned about an alleged breach of privacy law or any other regulation, contact EY’s Global Privacy
      Leader, Office of the General Counsel, 6 More London Place, London, SE1 2DA, United Kingdom or via email at
      global.data.protection@ey.com or via your usual EY representative. An EY Privacy Leader will investigate your
      complaint and provide information about how it will be handled and resolved.
      If you are not satisfied with how EY resolved your complaint, you have the right to complain to your country’s
      data protection authority. You can also refer the matter to a court of competent jurisdiction.

      <br><br><b>12. Contact us</b><br>
      If you have additional questions or concerns, contact your usual EY representative or email
      <a href="mailto:global.data.protection@ey.com">global.data.protection@ey.com</a>.
    </p>
  </div>
  <br>
  <p style="font-size: 12px">Please review the EY Privacy Statemnet and move forward to accept or decline acceptance.
  </p>
  <br>
  <span style="font-size: 16px">Do you consent with the privacy statement?</span>
  <br><br>
  <form [formGroup]="ConsentForm" (ngSubmit)="updateSecurityCheck()">
    <mat-radio-group formControlName="IsConsent">
      <mat-radio-button value="true">Yes, I consent
      </mat-radio-button><br>
      <mat-radio-button value="false">No, I do not consent</mat-radio-button>
    </mat-radio-group>
    <div style="text-align: center"> <button type="submit" style="width: 20%" mat-stroked-button
        [disabled]="!ConsentForm.valid">Submit</button></div>
  </form>
</mat-dialog-content>